import React, { useEffect, useState } from "react";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import { Select } from "semantic-ui-react";
import SearchDropdown from "../../input/SearchDropdown";
import { statusByContext } from "../../../api/statusApi";
import LoadingSpinner from "../../LoadingSpinner";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import { STATUS_GROUPS } from "../../../const";
import Input from "../../input/Input";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {downloadJobSummaryExcel} from "../../../api/reportApi";

const JobReportSearch = ({ searchResHandler, resetHandler }) => {
  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);

  const [dateTypeOptions, setDateTypeOptions] = useState([]);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);

  const [dateType, setDateType] = useState(1);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [customer, setCustomer] = useState("");
  const [billingCustomer, setBillingCustomer] = useState("");
  const [invoicingCustomer, setInvoicingCustomer] = useState("");
  const [transporter, setTransporter] = useState("");
  const [shipper, setShipper] = useState("");
  const [jobStatus, setJobStatus] = useState([]);
  const [jobNos, setJobNos] = useState("");
  const [requestNos, setRequestNos] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [vehicleNos, setVehicleNos] = useState("");
  const [status, setStatus] = useState("");
  const [active, setActive] = useState("");

  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reloadDates, setReloadDates] = useState(true);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [downloading , setDownloading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const {
        date_types: dateTypeData,
        status: statusData,
        active: activeData,
      } = await getBulkDropdownData([
        { key: "date_types" },
        { key: "status" },
        { key: "active" },
      ]);

      setDateTypeOptions(dateTypeData);
      setStatusOptions(statusData);
      setActiveOptions(activeData);

      const jobStatusData = await statusByContext(
        userData.type === 2
          ? STATUS_GROUPS.CUSTOMER_STATUS
          : userData.type === 3
            ? STATUS_GROUPS.TRANSPORTER_STATUS
            : STATUS_GROUPS.ALL
      );
      setJobStatusOptions(jobStatusData);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const onSearch = (e) => {
    if (!dateType || !fromDate || !toDate) {
      toast.warn("Date range and date type is mandatory", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    e.preventDefault();
    searchResHandler({
      dateType: dateType,
      fromDate: getValueOrDefault(fromDate),
      toDate: getValueOrDefault(toDate),
      customer: getValueOrDefault(customer),
      billingCustomer: getValueOrDefault(billingCustomer),
      invoicingCustomer: getValueOrDefault(invoicingCustomer),
      transporter: getValueOrDefault(transporter),
      shipper: getValueOrDefault(shipper),
      jobStatus: getValueOrDefault(jobStatus),
      jobNos: getValueOrDefault(jobNos),
      requestNos: getValueOrDefault(requestNos),
      vehicleType: getValueOrDefault(vehicleType),
      vehicleNos: getValueOrDefault(vehicleNos, "-2").toUpperCase(),
      status: getValueOrDefault(status),
      active: getValueOrDefault(active),
      reportName: "job_report",
    });
  };

  function getValueOrDefault(value, defaultValue = "-2") {
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(",") : defaultValue;
    }
    return value && value.toString().trim() !== ""
      ? value.toString()
      : defaultValue;
  }

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setDateType(1);
    setCustomer("");
    setBillingCustomer("");
    setInvoicingCustomer("");
    setTransporter("");
    setShipper("");
    setJobStatus("");
    setJobNos("");
    setRequestNos("");
    setVehicleNos("");
    setVehicleType("");
    setStatus("");
    setActive("");
    setReloadDates(true);
    resetHandler();

    setTimeout(() => setResetSearchFields(false), 0);
  };

  const onDownload = async (e) => {
    e.preventDefault();

    setDownloading(true);

    if (!dateType || !fromDate || !toDate) {
      toast.warn("Date range and date type is mandatory", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }

    const payload = {
      dateType,
      fromDate,
      toDate,
      customer: getValueOrDefault(customer),
      billingCustomer: getValueOrDefault(billingCustomer),
      invoicingCustomer: getValueOrDefault(invoicingCustomer),
      transporter: getValueOrDefault(transporter),
      shipper: getValueOrDefault(shipper),
      jobStatus: getValueOrDefault(jobStatus),
      jobNos: getValueOrDefault(jobNos),
      requestNos: getValueOrDefault(requestNos),
      vehicleType: getValueOrDefault(vehicleType),
      vehicleNos: getValueOrDefault(vehicleNos).toUpperCase(),
      status: getValueOrDefault(status),
      active: getValueOrDefault(active),
      reportName: "job_report",
    };

    try {
      const excelBlob = await downloadJobSummaryExcel(payload);
      const url = window.URL.createObjectURL(new Blob([excelBlob]));

      const formattedFromDate = fromDate;
      const formattedToDate = toDate;

      const fileName = `REPORT OF JOB SUMMARY ${formattedFromDate} TO ${formattedToDate}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      toast.error("Excel download failed");
    } finally {
      setDownloading(false);
    }
  };


  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form">
          <h4 className="ui dividing header">Information</h4>
          <div
            className="three fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div className="field">
              <Dropdown
                required={true}
                options={dateTypeOptions}
                label="Date Type"
                placeholder="Date Type"
                style={{ height: "20px" }}
                value={dateType}
                onChange={(e, data) => {
                  setDateType(data.value);
                }}
                clearable={false}
              />
            </div>
            <div className="field">
              <Input
                required={true}
                type="date"
                label="From Date"
                name="fromDate"
                max={toDate ?? new Date().toISOString().split("T")[0]}
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                }}
              />
            </div>
            <div className="field">
              <Input
                required={true}
                label="To Date"
                type="date"
                name="toDate"
                min={fromDate}
                value={toDate}
                disabled={!fromDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                }}
              />
            </div>
          </div>
          <div
            className="four fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {userData.type === 1 ? (
                <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple={true}
                    multiValueRemoveHandler={(key) => {
                      setCustomer((prev) =>
                          prev.filter((item) => item !== parseInt(key)),
                      );
                    }}
                    onResultSelect={(data) =>
                        setCustomer((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Customer",
                    }}
                    label="Request Customer"
                />
            ) : (
                <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple={true}
                    multiValueRemoveHandler={(key) => {
                      setCustomer((prev) =>
                          prev.filter((item) => item !== parseInt(key)),
                      );
                    }}
                    onResultSelect={(data) =>
                        setCustomer((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "user_stakeholder",
                      value: "Requesting Customer",
                      param2: user.username,
                    }}
                    label="Request Customer"
                />
            )}
            <div className="field">
              <label>Request Numbers</label>
              <input
                type="text"
                placeholder=" Ex:REQ-00000123"
                name="reqnos"
                value={requestNos}
                onChange={(e) => {
                  setRequestNos(e.target.value);
                }}
              />
            </div>
            <div className="field">
              <label>Job Numbers</label>
              <input
                type="text"
                placeholder="Ex:JOB-0000123"
                name="jobnos"
                value={jobNos}
                onChange={(e) => {
                  setJobNos(e.target.value);
                }}
              />
            </div>
            <div className="field">
              <Dropdown
                clearable
                search={true}
                options={jobStatusOptions}
                placeholder="Job Status"
                label="Job Status"
                value={jobStatus}
                onChange={(e, data) => {
                  setJobStatus(data.value);
                }}
                multiple={true}
              />
            </div>
          </div>
          <div
            className="four fields"
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div className="field">
              <SearchDropdown
                  key={
                    resetSearchFields
                        ? `vehicle_type_reset_${Date.now()}`
                        : "vehicle_type"
                  }
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  occupySpace={false}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setVehicleType((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  onResultSelect={(data) =>
                      setVehicleType((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "vehicle_type",
                    value: "",
                  }}
                  label="Vehicle Type"
              />
            </div>
            <div className="field">
              <label>Vehicle Numbers</label>
              <input
                type="text"
                placeholder="Example - 1,2,3"
                name="vehnos"
                value={vehicleNos}
                onChange={(e) => {
                  setVehicleNos(e.target.value);
                }}
              />
            </div>
            <div className="field">
              <label>Status</label>
              <Select
                clearable
                options={statusOptions}
                placeholder="Status"
                style={{ height: "20px" }}
                value={status}
                onChange={(e, data) => {
                  setStatus(data.value);
                }}
              />
            </div>
            <div className="field">
              <label>Active</label>
              <Select
                clearable
                options={activeOptions}
                placeholder="Active"
                style={{ height: "20px" }}
                value={active}
                onChange={(e, data) => {
                  setActive(data.value);
                }}
              />
            </div>
          </div>
          <div
              className="four fields"
              style={{
                display: "flex",
                flexDirection: "row",
              }}
          >
              <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  occupySpace={false}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setShipper((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  onResultSelect={(data) => setShipper((prev) => [...prev, data])}
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 1
                        ? {
                          type: "stakeholder_type",
                          value: "Shipper",
                          param2: customer.length > 0 ? customer.join(",") : "",
                        }
                        : {
                          type: "user_stakeholder",
                          value: "Shipper",
                          param1: customer.length > 0 ? customer.join(",") : "",
                          param2: user.username,
                        }
                  }
                  label="Shipper/Plant"
              />
              <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  occupySpace={false}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setTransporter((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  onResultSelect={(data) =>
                      setTransporter((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 3
                        ? {
                          type: "user_stakeholder_all",
                          value: "Transporter",
                          param2: user.username,
                        }
                        : {
                          type: "stakeholder_type",
                          value: "transporter_all",
                        }
                  }
                  label="Transporter"
              />
              <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  clearable={true}
                  onClear={() => {
                    setBillingCustomer("");
                  }}
                  onResultSelect={(data) => setBillingCustomer(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Billing Customer",
                  }}
                  label="Billing Customer"
              />
            <SearchDropdown
                key={1}
                editMode={false}
                reset={resetSearchFields}
                setReset={setResetSearchFields}
                clearable={true}
                onClear={() => {
                  setInvoicingCustomer("");
                }}
                onResultSelect={(data) => setInvoicingCustomer(data)}
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "stakeholder_type",
                  value: "Invoicee Customer",
                }}
                label="Invoicee Customer"
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="field" style={{ width: "100%" }}>
              <Button template="generateReport" onClick={onDownload} isLoading={downloading}/>
              <Button template="search" onClick={onSearch} />
              <Button template="searchReset" onClick={onReset} />
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default JobReportSearch;
